/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".primary-container[_ngcontent-%COMP%]:hover   .link-actions-container[_ngcontent-%COMP%]{visibility:visible}.link-text[_ngcontent-%COMP%]{position:relative;color:#4aaed9;cursor:pointer}.link-actions-container[_ngcontent-%COMP%]{visibility:hidden;position:absolute;top:0;left:105%;width:calc(100% + 16px * 5);z-index:4}.link-actions-container[_ngcontent-%COMP%]   .link-action[_ngcontent-%COMP%]{margin-left:.1rem}.link-actions-container[_ngcontent-%COMP%]   .link-action[_ngcontent-%COMP%]:hover{color:#abd9ed}"];
export { styles as styles };

